import {
    baseUrl,
    isSignedIn,
    getHeaders,
    getMultipartHeaders,
    getDomain,
} from "@services/AuthServices";
import { queryFilter } from "@src/filters/query-filter";

export async function UserServicesAcceptsTerms(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/${userId}/acceptterms`;

    return axios.put(urlApi, { userId }, getHeaders());
}

export async function UserServicesCreateUserTest(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/test-account?domain=${getDomain()}&isB2B=true`;

    return axios.post(urlApi, body, getHeaders());
}

export async function UserServicesConfirmUserTest(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/test-account-activation`;

    return axios.put(urlApi, body, getHeaders());
}

export async function UserServicesGetNotifications(filters) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/User/notifications${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function UserServicesChangeStatusNotification(
    notificationId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/notification/${notificationId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function UserServicesDeleteNotification(notificationId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/notification/${notificationId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function UserServicesDeleteListNotification(notificationIds) {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/notification/`;

    const headers = getHeaders();

    return await axios.delete(urlApi, {
        params: {
            notificationIds: notificationIds.join(',')
        },
        ...headers
    });
}

export async function UserServicesListActiveUsers() {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/dropdown/all-active`;

    return axios.get(urlApi, getHeaders());
}

export async function UserServicesGetUserSettings(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/${userId}/settings`;

    return axios.get(urlApi, getHeaders());
}

export async function UserServicesPutUserSettings(body, userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/${userId}/settings`;

    return axios.put(urlApi, body, getMultipartHeaders());
}

export async function UserServicesSendStremaTicket(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/strema`;

    return axios.post(urlApi, body, getMultipartHeaders());
}

export async function UserServicesGetSTREMAConfigurations(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/strema/${userId}`;

    return axios.get(urlApi, getHeaders());
}

export async function UserServicesGetErpSilentLoginURL() {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/erp/silent-login-url`;

    return axios.get(urlApi, getHeaders());
}

export async function UserServicesGetRmiShortcuts(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/${userId}/rmi/config/shortcuts`;

    return axios.get(urlApi, getHeaders());
}

export async function UserServicesGetRmiShortcutsDD() {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/rmi/shortcuts`;

    return axios.get(urlApi, getHeaders());
}

export async function UserServicesGetRmiShortcutsDDStep2(rmiShortcutId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/rmi/shortcut/${rmiShortcutId}`;

    return axios.get(urlApi, getHeaders());
}

export async function UserServicesGetBusinessConditions(userId, moduleId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/${userId}/module/${moduleId}/business-conditions`;

    return axios.get(urlApi, getHeaders());
}

export async function UserServicesToggleBrowserNotifications(userId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/User/${userId}/chat/toggle-browser-notifications`;

    return axios.post(urlApi, body, getHeaders());
}

export async function UserServicesGetExternalUsers(tableFilters) {
    await isSignedIn();

    let query = queryFilter(tableFilters);
    let urlApi = `${baseUrl}/User/externals${query}`;

    return axios.get(urlApi, getHeaders(true));
}